import authentication from "@irati/auth"
import walletGraph from "../../graph/wallet"
import getWalletCurrency from "../../helpers/getWalletCurrency"

export const GET_WALLET = {}
export const REQUEST_WALLET = {}
export const CLEAR_WALLET = {}

export const get = (wallet) => {
  return {
    type: GET_WALLET,
    wallet
  }
}

export const request = () => {
  return {
    type: REQUEST_WALLET
  }
}

export const getWallet = () => {
  return (dispatch) => {
    dispatch(request())
    const {user, userLocale} = authentication
    return walletGraph.get(user().uuid, getWalletCurrency(userLocale())).then((wallet) => {
      return dispatch(get(wallet))
    })
  }
}

export const clear = () => {
  return {
    type: CLEAR_WALLET
  }
}

export default {
  get: getWallet,
  clear
}
